import React, {useEffect} from "react";
import DispatchCards from "./components/dispatch-cards.jsx";
import SupportAmount from "./components/support-amount.jsx";
import DisplacementAmount from "./components/displacement-amount.jsx";
import DispatchDuration from "./components/dispatch-duration.jsx";
import DispatchesByGarrisonClass from "./components/dispatches-by-garrison-class.jsx";
import BoStatus from "./components/bo-status.jsx";
import DispatchesByWeekDay from "./components/dispatches-by-weekday.jsx";
import DispatchesByPlaces from "./components/dispatches-by-places.jsx";
import DispatchesByAddress from "./components/dispatches-by-address.jsx";
import DispatchesByNeighborhood from "./components/dispatches-by-neighborhood.jsx";
import DispatchesByPhones from "./components/dispatches-by-phones.jsx";
import DispatchesByNature from "./components/dispatches-by-nature.jsx";
import DispatchesByNatureGroup from "./components/dispatches-by-nature-group.jsx";
const ReportContent = ({data, collapsed}) => {
  return(
    <>
      <DispatchCards key={`cards-${collapsed}`} data={data?.dispatchCards} boName={data?.boName} dispatchList={data?.dispatchList}/>
      <SupportAmount key={`support-${collapsed}`} data={data?.supportAmount}/>
      <DisplacementAmount key={`displacement-amount-${collapsed}`} data={data?.displacementAmount}/>
      <DispatchDuration key={`dispatch-duration-${collapsed}`} data={data?.dispatchDuration} avgDispatchTime={data?.dispatchCards?.avg_dispatch_time}/>
      <DispatchesByGarrisonClass key={`dispatches-by-garrison-class-${collapsed}`} data={data?.dispatchesByGarrisonClass}/>
      <BoStatus key={`bo-status-${collapsed}`} data={data?.boStatus} boName={data?.boName}/>
      <DispatchesByWeekDay key={`dispatches-by-week-day-${collapsed}`} data={data?.dispatchesByWeekday}/>
      <DispatchesByPlaces key={`dispatches-by-places-${collapsed}`} data={data?.dispatchesByPlaces}/>
      <DispatchesByAddress key={`dispatches-by-address-${collapsed}`} data={data?.dispatchesByAddress}/>
      <DispatchesByNeighborhood key={`dispatches-by-neighborhood-${collapsed}`} data={data?.dispatchesByNeighborhoods}/>
      <DispatchesByPhones key={`dispatches-by-phones-${collapsed}`} data={data?.dispatchesByPhones}/>
      <DispatchesByNature key={`dispatches-by-nature-${collapsed}`} data={data?.dispatchesByNature}/>
      <DispatchesByNatureGroup key={`dispatches-by-nature-group-${collapsed}`} data={data?.dispatchesByNatureGroups}/>
      <div id="chart-tables"></div>
    </>
  )
}

export default ReportContent;